import React, { useState, useEffect } from 'react';
import { Shield, X, HelpCircle } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

const DISMISS_KEY = 'kaicheckit_mobile_hint_dismissed';

const FloatingWidget = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showMobileHint, setShowMobileHint] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile device
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Only show on homepage for mobile users who haven't dismissed
  useEffect(() => {
    if (isMobile && location.pathname === '/') {
      const dismissed = localStorage.getItem(DISMISS_KEY);
      if (!dismissed) {
        // Show hint after a short delay
        const timer = setTimeout(() => setShowMobileHint(true), 2000);
        return () => clearTimeout(timer);
      }
    } else {
      setShowMobileHint(false);
    }
  }, [isMobile, location.pathname]);

  const handleDismiss = () => {
    setShowMobileHint(false);
    localStorage.setItem(DISMISS_KEY, 'true');
  };

  // Don't render anything on desktop - desktop users have the browser extension
  if (!isMobile) {
    return null;
  }

  // Mobile: Show small dismissable hint about adding to home screen
  if (!showMobileHint) {
    return null;
  }

  return (
    <div className="fixed bottom-20 right-4 z-[9999] animate-in slide-in-from-right duration-300">
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700 p-3 max-w-[200px]">
        <div className="flex items-start gap-2">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
            <Shield className="w-4 h-4 text-white" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-slate-600 dark:text-slate-400 leading-tight">
              Add KaiCheckIt to your home screen for quick access!
            </p>
          </div>
          <button
            onClick={handleDismiss}
            className="p-1 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 flex-shrink-0"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <Button
          onClick={() => {
            handleDismiss();
            navigate('/share');
          }}
          size="sm"
          className="w-full mt-2 bg-blue-600 hover:bg-blue-700 text-xs h-7"
        >
          Learn How
        </Button>
      </div>
    </div>
  );
};

export default FloatingWidget;
